<template>
  <div v-if="hasNode">
    <VNode :node="node" :item="item"/>
  </div>
  <span v-else>
    {{ hasValue ? format(this.localValue) : 'N/D' }}
  </span>
</template>

<script>
import _ from 'lodash'
import { useReactiveModelMixin } from '../../mixins'

const reactiveValueMixin = useReactiveModelMixin(
  'value',
  {
    type: [ String, Number ],
    default: '',
    required: false
  })

const reactiveFormatMixin = useReactiveModelMixin(
  'format',
  {
    type: Function,
    default: value => value,
    required: false
  },
  false)

export default {
  name: 'NxDataGridRow',
  mixins: [
    reactiveValueMixin,
    reactiveFormatMixin
  ],
  components: {
    VNode: {
      functional: true,
      render: (_, ctx) => {
        for (let i in ctx.props.node) {
          ctx.props.node[i].componentOptions.propsData.item = ctx.props.item
        }

        return ctx.props.node
      }
    }
  },
  props: {
    node: {
      type: [Array, Node],
      default: null,
      required: false
    },
    item: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {
    hasValue () {
      return !_.isNil(this.localValue)
    },
    hasNode () {
      return this.node !== null && this.node !== undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/datagrid/NxDataGridRow.vue